import { Button, Col, Form, Input, Row, Select } from "antd";
import React from "react";
import { v4 as uuidv4 } from "uuid";

const months = [{value: "Month to Month"}];
for(let i=1; i<=100; i++){
    months.push({value: `${i} Month`})
}

function Terms({changeRentBy, terms, setTerms}) {

  const addTerm = () => {
    const newTerm = { id: uuidv4(), term: "", changeByAmount: "", additionalFee: "" };
    setTerms([...terms, newTerm]);
  };

  const removeTerm = (id) => {
    const updatedTerms = terms.filter((term) => term.id !== id);
    setTerms(updatedTerms);
  };

  const handleChange = (value, name, id) => {
    const updatedTerms = terms.map((term) => {
      if (term.id === id) {
        return { ...term, [name]: value };
      }
      return term;
    });
    setTerms(updatedTerms);
  };
  
  return (
    <>
      {terms.map((term) => (
        <Row gutter={[8,0]} key={term.id}>
          <Col span={10}>
            <Form.Item key={term.id} name={`term${term.id}`}>
              <Select
                value={term.term}
                onChange={(value) => handleChange(value, 'term', term.id)}
                options={months}
                showSearch
                placeholder="Choose term"
              />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item key={term.id} name={`changeBy${term.id}`}>
              {changeRentBy === "dollar" ? <Input
                value={term.changeBy}
                onChange={(e) => handleChange(e.target.value, 'changeByAmount', term.id)}
                prefix="$"
              /> : <Input
              value={term.changeBy}
              onChange={(e) => handleChange(e.target.value, 'changeByAmount', term.id)}
              suffix="%"
            />}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item key={term.id} name={`additionalFee${term.id}`}>
              <Input
                value={term.addtionalFee}
                onChange={(e) => handleChange(e.target.value, 'additionalFee', term.id)}
              />
            </Form.Item>
          </Col>
          <Col span={1}>
            {terms.length > 1 && (
              <Button className="roundSmallButton" onClick={() => { removeTerm(term.id) }} type="primary" shape="circle" icon={<i className="fa-sharp fa-solid fa-xmark"></i>} size={"small"} />
            )}
          </Col>
        </Row>
      ))}
        <Button className="addPropertyGroupButton" type="primary" onClick={()=>addTerm()} size={"small"} icon={<i className="fa-solid fa-circle-plus" ></i>} style={{width:"100%"}}> Add Another Term</Button>
    </>
  );
}

export default Terms;
